import React from 'react';
import { useTranslation } from 'react-i18next';
import ComingSoon from './ComingSoon';

const RetentionPolicies = () => {
  const { t } = useTranslation();
  return <ComingSoon title={t('settings.menu.retentionPolicies')} />;
};

export default RetentionPolicies;
